export const messages = {
  templateInfo: {
    id: 'admin/promotions.form.template.info',
  },
  moreInformation: {
    id: 'admin/promotions.utils.more-information',
  },
  moreInformationLink: {
    id: 'admin/promotions.links.template.more-information',
  },
  header: {
    newTemplate: {
      id: 'admin/promotions.form.new-template',
    },
  },
}
